/* eslint-disable no-tabs */
import actionLabelMap from './articleActionLabelMap'
import topLevelActionsModel, { ACTION_PRIMARY, ACTION_SECONDARY } from './topLevelActionsModel'

/**
 * Article labels map
  action_chat_primary ->	      <button class="o-btn o-bt--primary">chat-text</button>
  action_chat ->                <button class="o-btn o-btn--secondary">chat-text</button>
  action_refund_primary ->	    <button class="o-btn o-btn--primary">refund-text</button>
  action_refund ->	            <button class="o-btn o-btn--secondary">refund-text</button>
  action_redeliver_primary ->	  <button class="o-btn o-bt--primary">redeliver-text</button>
  action_redeliver ->           <button class="o-btn o-btn--secondary">redeliver-text</button>
  action_order_again_primary ->	<a href="order-again-url" class="o-btn o-bt--primary">order-again-text</a>
  action_order_again ->	        <a href="order-again-url" class="o-btn o-btn--secondary">order-again-text</a>
 */

/**
 * Generate Article Contact action from Article Label names
 * to match CHAPI `topLevelActions` schema
 * Note: `actionLabel` should be one of `actionLabelMap`
 * @param {String} actionLabel one of the `actionLabelMap` labels
 * @returns {Object} Contact action in CHAPI `topLevelActions` schema
 */
export const generateActionFromLabel = actionLabel => {
  let action = {}
  switch (actionLabelMap[actionLabel].type) {
    case 'live_chat':
      action = { ...topLevelActionsModel.liveChat }
      action.message = actionLabelMap[actionLabel].message
      break
    case 'link':
      action = { ...topLevelActionsModel.phone }
      action.id = 'ActionLink'
      action.type = 'Link'
      action.action = '/'
      break
    default:
      return null
  }

  action.buttonType =
    actionLabel.match(/primary/gi) !== null
      ? ACTION_PRIMARY
      : ACTION_SECONDARY
  action.titleKey = actionLabelMap[actionLabel].text

  return action
}

/**
 * Extracts Actions from article labels and formats them in CHAPI response `topLevelActions` style
 * @param {Object} article Selected Article object
 * @returns {Array} actionLabels in the format of topLevelActions e.g. CHAPI reponse
 */
const articleActionsFromLabel = article => {
  const actions = []
  const actionLabels =
    article && article.LabelNames.filter(l => l.match(/action/gi) && actionLabelMap[l])

  actionLabels && actionLabels.forEach(label => {
    const action = generateActionFromLabel(label)
    actions.push(action)
  })
  return actions
}
export default articleActionsFromLabel
